function isVrioOttError(error) {
  return typeof error === "object" && error !== null && "isVrioOttError" in error && error.isVrioOttError === true;
}

export { isVrioOttError };
//# sourceMappingURL=isVrioOttError.js.map
